import { EventEmitter } from 'eventemitter3';
import { TUNING } from '../config/tuning';

export class JointController extends EventEmitter {
  static EVT_LENGTH_CHANGED = 'joint:length-changed';
  static EVT_DEPLETED = 'joint:depleted';
  static EVT_ENTERED_CARDBOARD = 'joint:entered-cardboard';

  private lengthPct: number;
  private inCardboard = false;

  constructor() {
    super();
    this.lengthPct = TUNING.joint.initialLengthPct;
  }

  reset(): void {
    this.lengthPct = TUNING.joint.initialLengthPct;
    this.inCardboard = false;
    this.emit(JointController.EVT_LENGTH_CHANGED, this.lengthPct);
  }

  /** Burn the joint while someone is actively inhaling. Returns true if just depleted. */
  consume(deltaSeconds: number): boolean {
    if (this.lengthPct <= 0) return false;
    const next = Math.max(0, this.lengthPct - TUNING.joint.depletionPctPerSec * deltaSeconds);
    const prev = this.lengthPct;
    this.lengthPct = next;
    this.emit(JointController.EVT_LENGTH_CHANGED, next);
    if (!this.inCardboard && next <= TUNING.joint.cardboardZonePct) {
      this.inCardboard = true;
      this.emit(JointController.EVT_ENTERED_CARDBOARD);
    }
    if (prev > 0 && next <= 0) {
      this.emit(JointController.EVT_DEPLETED);
      return true;
    }
    return false;
  }

  getLengthPct(): number {
    return this.lengthPct;
  }

  isInCardboard(): boolean {
    return this.inCardboard;
  }

  isDepleted(): boolean {
    return this.lengthPct <= 0;
  }
}
